


import React, { useEffect, useState, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "./storage";
import { ToastContainer, toast } from "react-toastify";

// Components
import Searchbar from "./Shearchbar";
import Manubar from "./Manubar";
import Footer from "./Footer";

// Styles
import "./m.css";
import "./loader.css";
import "react-toastify/dist/ReactToastify.css";

const Single_products = () => {
  const { id } = useParams();
  const [productDetails, setProductDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get data from storage
  const token = secureLocalStorage.getItem("n_token");
  const productsDetails = id;
  const _id = secureLocalStorage.getItem("n_id");

  // Fetch product details
  const fetchProductDetails = useCallback(async () => {
    if (!productsDetails) {
      toast.error("Product ID is missing");
      return;
    }

    const controller = new AbortController();
    try {
      setLoading(true);

      const payload = { product_id: productsDetails };

      // Add user_id ONLY if user is logged in AND _id exists
      if (_id && _id.trim() !== "") {
        payload.user_id = _id;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/product_details`,
        payload,
        {
          headers: token && token.trim() !== "" ? { token } : {},
          signal: controller.signal,
        }
      );

      if (res?.data?.result) {
        setProductDetails(res.data.data);
      } else {
        toast.error("Failed to load product details");
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Error fetching product:", error);
        toast.error("Error loading product details");
      }
    } finally {
      setLoading(false);
    }

    return () => controller.abort();
  }, [productsDetails, _id, token]);

  useEffect(() => {
    fetchProductDetails();
  }, [fetchProductDetails]);

  // Grab Deal action -> sends user to the actual platform (Myntra/Amazon/etc.)
  // NOTE: replace "product_link" below with whatever field name your API
  // actually returns for the external/affiliate URL.
  const handleGrabDeal = () => {
    const dealUrl = productDetails[0]?.product_link || productDetails[0]?.affiliate_link;

    if (!dealUrl) {
      toast.error("Deal link not available right now");
      return;
    }
    window.open(dealUrl, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader"></div>
      </div>
    );
  }

  const product = productDetails?.[0];

  // ---- PLACEHOLDER CONTENT ----
  // These 3 sections (Tracking / Important Info / How to get offer) are not
  // part of the current API response yet. Once the backend adds these
  // fields, swap the hardcoded arrays below with `product?.tracking_info`,
  // `product?.important_info`, `product?.how_to_get_offer` etc.
  const trackingInfo = [
    `Tracking Time: ${product?.tracking_time || "36 Hours"}`,
    `Confirmation Timeline: ${product?.confirmation_timeline || "75 Days"}`,
  ];

  const importantInfo = product?.important_info || [
    "Do not add products to your Cart/Wishlist before visiting the platform through our link",
    "Only use coupon codes available exclusively on our platform",
    "Cashback is calculated based on the order value, excluding platform/shipment fee",
    "Cashback will be cancelled if the order is exchanged or replaced",
  ];

  const howToGet = product?.how_to_get_offer || [
    "Click on the Grab Deal button below",
    "Shop there as you normally would",
    "Cashback will be added to your account",
  ];
  // ---- END PLACEHOLDER CONTENT ----

  return (
    <div className="single-product-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Searchbar />
      </header>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section bg-light py-3">
        <div className="container">
          <ol className="breadcrumb m-0 p-0 align-items-center">
            <li className="breadcrumb-item">
              <Link to="/" className="text-decoration-none text-muted">
                Home
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/shop" className="text-decoration-none text-muted">
                Products
              </Link>
            </li>
            <li className="breadcrumb-item active text-dark fw-semibold">
              {product?.product_name}
            </li>
          </ol>
        </div>
      </nav>

      {product ? (
        <section className="py-5">
          <div className="container">
            <div className="row g-5">
              {/* LEFT: single image + Grab Deal button */}
              <div className="col-lg-5">
                <div className="product-image-section bg-white rounded-3 shadow-sm p-3 position-relative">
                  {product?.offer_percent > 0 && (
                    <span className="badge bg-danger position-absolute top-0 start-0 m-2 fs-6">
                      -{product?.offer_percent}%
                    </span>
                  )}
                  <div className="text-center">
                    <img
                      className="img-fluid rounded-2"
                      src={`${process.env.REACT_APP_API}uploads/${product?.product_image?.[0]}`}
                      alt={product?.product_name}
                      style={{ maxHeight: "400px", width: "auto", objectFit: "contain" }}
                    />
                  </div>
                </div>

                {token ? (
  <button
    className="btn btn-lg w-100 mt-3 fw-semibold text-white border-0"
    style={{ background: "linear-gradient(135deg, #ff4b2b, #c01e12)" }}
    onClick={handleGrabDeal}
  >
    Grab Deal
  </button>
) : (
  <Link
    to="/login"
    className="btn btn-lg w-100 mt-3 fw-semibold text-white text-decoration-none border-0"
    style={{ background: "linear-gradient(135deg, #ff4b2b, #c01e12)" }}
  >
    Grab Deal
  </Link>
)}
              </div>

              {/* RIGHT: offer details */}
              <div className="col-lg-7">
                <h1 className="h2 fw-bold text-dark mb-1">{product?.product_name}</h1>
                <div className="text-muted mb-4">
                  <strong>Category:</strong> {product?.category_name}
                </div>

                {/* Pricing */}
                <div className="d-flex align-items-center flex-wrap gap-3 mb-4">
                  <span className="h4 fw-bold text-primary mb-0">
                    ₹{product?.price?.[0]?.toFixed?.(2) ?? product?.price?.[0]}
                  </span>
                  {product?.mrp && (
                    <span className="h6 text-muted text-decoration-line-through mb-0">
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  )}
                  {product?.mrp && product?.price?.[0] && (
                    <span className="badge bg-success fs-6">
                      Save ₹{(product.mrp - product.price[0]).toFixed(2)} (
                      {Math.round(((product.mrp - product.price[0]) / product.mrp) * 100)}%)
                    </span>
                  )}
                </div>

                {/* About the Offer */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-2">About the Offer</h5>
                  <ul className="mb-0">
                    <li>{product?.description}</li>
                  </ul>
                </div>

                {/* Tracking Information */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-2">Tracking Information</h5>
                  <ul className="mb-0">
                    {trackingInfo.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* Important Information */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-2">Important Information</h5>
                  <ul className="mb-0">
                    {importantInfo.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>

                {/* How to get this offer */}
                <div className="mb-4">
                  <h5 className="fw-bold mb-2">How to get this offer</h5>
                  <ul className="mb-0">
                    {howToGet.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <div className="text-center py-5">
          <div className="loader"></div>
          <p className="text-muted mt-3">Loading product details...</p>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Single_products;
